/* eslint-disable eqeqeq */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef } from "react";
import {
  currentDateWithFormat,
  getDaybyDate,
  getPathForSurvey,
  minusDayOnDate,
  minusMonthOnDate,
} from "../../utils/helper";
import { IoMdArrowDropup } from "react-icons/io";
import { Bar } from "react-chartjs-2";
import { useLocation, useNavigate } from "react-router-dom";
import Topbar from "../../container/PulseSurvey/Topbar";
import { errorToast } from "../../utils/helper";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Api } from "../../api";
import ValueCards from "../../component/common/cards/valueCard";
import HorizontalListCard from "../../component/common/cards/horizontalListCard";
import AddSurveyPopup from "../../component/common/modals/CreatePopup";
import moment from "moment";
import Loader from "../../component/common/Loader";
import { ChevronDownIcon } from "@heroicons/react/24/outline";
import { AGERANGE } from "../../utils/constants";
import { SelfAssessmentPageData } from "../../utils/experienceConstants";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const SelfAssessmentDashboard = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const wrapperRef = useRef(null);
  const filterModalRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState("Date Created");
  const [assessmentData, setAssessmentData] = useState([]);
  const [isShowDropdown, setIsShowDropdown] = useState(false);
  const [assessmentId, setAssessmentId] = useState(null);
  const [assessmentMatrics, setAssessmentMatrics] = useState({});
  const totalUsers = assessmentMatrics?.weeklyStats
    ?.map((item) => item?.uniqueUserCount)
    ?.reduce((a, b) => a + b, 0);
  const [loader, setLoader] = useState(true);

  const popupOption = ["attatchment", "percentage"];
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [parameters, setParameters] = useState({
    dateCriteria: "1",
    location: "",
    common_time: "Morning",
    age: "",
    gender: "",
    template_type: "",
    startDate: new Date(),
    endDate: new Date(),
    ethinicity: "",
  });

  const [dateCalender, setDateCalander] = useState(false);
  const [model, setModel] = useState({
    datePickerVisible: false,
    dateChanged: false,
    dateButtonVisible: false,
  });
  const [filterData, setFilterData] = useState({
    countries: [],
    ethnicities: [],
  });

  const togglePopUp = () => {
    setIsPopupOpen((prev) => !prev);
  };

  const handlePopupOptionClick = (option) => {
    setIsPopupOpen(false);
  };

  const ProgressBar = ({ label, percentage }) => (
    <div className="mb-4">
      <div className="flex justify-between items-center mb-2">
        <span className="text-[16px] leading-[22px] font-medium">{label}</span>
        <span className="text-[12px] leading-[22px] font-medium text-[#67A14A]">
          {percentage}%
        </span>
      </div>
      <div className="w-full bg-[#C2EC97] rounded-full h-2">
        <div
          className="bg-[#67A14A] h-2 rounded-full"
          style={{ width: `${percentage}%` }}
        ></div>
      </div>
    </div>
  );

  const handleDeleteAssessment = (assessmentId) => {
    setLoader(true);
    Api.deleteAssessment(assessmentId)
      .then((response) => {
        if (response?.data?.meta?.code === 1) {
          getAssessmentData();
          setAssessmentId(null);
          setIsShowDropdown(null);
        }
      })
      .catch((error) => {
        console.log(error);
        errorToast(error?.response?.data?.message ?? "Unknown Error Occurred");
      })
      .finally(() => {
        setLoader(false);
      });
  };

  const getAssessmentData = () => {
    //fetch only published assessments whose status is 6
    setLoader(true);
    Api.getAssessment(null, "", 6, "", "").then((response) => {
      if (response?.data?.meta?.code === 1) {
        setLoader(false);
        setAssessmentData(response?.data?.data);
      }
    });
  };

  const getAssessmentMatricsData = () => {
    setLoader(true);
    Api.getAssessmentMatrics("").then((response) => {
      setLoader(false);
      setAssessmentMatrics(response?.data?.data);
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'dateCriteria' && value === '4') {
      setParameters({ ...parameters, [name]: value });
      setModel({ ...model, dateButtonVisible: true });
    } else if (name === 'dataType') {
      if (value === 'professional') {
        setParameters({ ...parameters, [name]: value });
      } else if (value === 'personal') {
        setParameters({ ...parameters, [name]: value });
      } else {
        setParameters({ ...parameters, [name]: value });
      }
    } else {
      setParameters({ ...parameters, [name]: value });
      setModel({ ...model, dateButtonVisible: false });
    }
  };

  const handleSelectRange = (e) => {
    let start = new Date(e?.selection?.startDate);
    start.setHours(new Date().getHours());
    start.setMinutes(new Date().getMinutes());
    start.setSeconds(new Date().getSeconds());
    let end = new Date(e?.selection?.endDate);
    end.setHours(new Date().getHours());
    end.setMinutes(new Date().getMinutes());
    end.setSeconds(new Date().getSeconds());
    setParameters({
      ...parameters,
      startDate: start,
      endDate: end,
      datePickerVisible: false,
      dateChanged: true,
    });
  };

  useEffect(() => {
    getAssessmentData();
    getAssessmentMatricsData();
  }, []);

  const dataD = assessmentMatrics?.weeklyStats && {
    labels: assessmentMatrics.weeklyStats
      ? assessmentMatrics?.weeklyStats.map((item) => getDaybyDate(item._id))
      : [],
    datasets: [
      {
        label: "Weekly Usage",
        data: assessmentMatrics?.weeklyStats.map(
          (item) => item.totalAssessments
        ),
        backgroundColor: "rgba(74, 87, 218, 1)",
        borderColor: "rgba(74, 87, 218, 1)",
        borderRadius: 3,
        borderWidth: 1,
      },
    ],
  };

  const data = {
    labels: [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ],
    datasets: [
      {
        label: "Weekly Usage",
        data: [0, 0, 0, 0, 0, 0, 0],
        backgroundColor: "rgba(74, 87, 218, 1)",
        borderColor: "rgba(74, 87, 218, 1)",
        borderWidth: 1,
      },
    ],
  };
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
    },
    scales: {
      x: {
        grid: {
          drawOnChartArea: false,
        },
      },
      y: {
        grid: {
          drawOnChartArea: false,
        },
        ticks: {
          beginAtZero: true,
          stepSize: 100,
          callback: function (value) {
            return value % 100 === 0 ? value : "";
          },
        },
      },
    },
  };

  let dateCategory = "";

  const getDate = () => {
    const obj = { startDate: "", endDate: "", minAge: "", maxAge: "" };
    const date = new Date();
    if (parameters.dateCriteria == "1") {
      obj.startDate = currentDateWithFormat(minusDayOnDate(date, 7));
      obj.endDate = currentDateWithFormat(date);
      dateCategory = "weekly";
    }
    if (parameters.dateCriteria == "2") {
      obj.startDate = currentDateWithFormat(minusDayOnDate(date, 30));
      obj.endDate = currentDateWithFormat(date);
      dateCategory = "monthly";
    }
    if (parameters.dateCriteria == "3") {
      obj.startDate = currentDateWithFormat(minusMonthOnDate(date, 12));
      obj.endDate = currentDateWithFormat(date);
      dateCategory = "yearly";
    }
    if (parameters.dateCriteria == "4") {
      obj.startDate = currentDateWithFormat(parameters?.startDate);
      obj.endDate = currentDateWithFormat(parameters?.endDate);
      dateCategory = "custom";
    }
    if (parameters.age !== "") {
      const data = AGERANGE.filter((e) => e.value == parameters.age);
      obj.minAge = data[0].content.min;
      obj.maxAge = data[0].content.max;
    }
    return obj;
  };

  const handleDone = () => {
    let query = "";

    const obj = { ...getDate() };
    parameters?.template_type &&
      (query += `&template_type=${parameters?.template_type}`);
    parameters?.age && (query += `&ageRange=${parameters?.age}`);
    parameters?.gender && (query += `&gender=${parameters?.gender}`);
    parameters?.ethinicity && (query += `&ethnicity=${parameters?.ethinicity}`);
    parameters?.location && (query += `&country=${parameters?.location}`);
    obj.startDate && (query += `&startDate=${obj.startDate}`);
    obj.endDate && (query += `&endDate=${obj.endDate}`);

    setLoader(true);
    Api.getAssessmentMatrics("", query).then((response) => {
      setLoader(false);
      setIsFilterOpen(false);
      setDateCalander(false);
      setAssessmentMatrics(response?.data?.data);
    });
  };
  const handleReset = () => {
    setParameters({
      dateCriteria: "1",
      location: "",
      age: "",
      gender: "",
      template_type: "",
      startDate: new Date(),
      endDate: new Date(),
      ethinicity: "",
    });
    setLoader(true);
    Api.getAssessmentMatrics("", "").then((response) => {
      setLoader(false);
      setIsFilterOpen(false);
      setAssessmentMatrics(response?.data?.data);
    });
  };

  const getFilterData = () => {
    setLoader(true);
    Api.getFilterData()
      .then((res) => {
        setLoader(false);
        setFilterData(res.data);
      })
      .catch((err) => {
        setLoader(false);
      });
  };

  useEffect(() => {
    getFilterData();
  }, []);

  const IncompleteAssigment =
    (assessmentMatrics?.assessment?.inCompletedCount * 100) /
    assessmentMatrics?.assessment?.total;

  return (
    <div className="mx-auto lg:max-w-[1640px] lg:mb-[45px] lg:pl-5">
      {loader && <Loader />}
      <Topbar
        title={SelfAssessmentPageData.topbarTitleText}
        isFilterOpen={isFilterOpen}
        setIsFilterOpen={setIsFilterOpen}
        parameters={parameters}
        handleChange={handleChange}
        filterData={filterData}
        location={location}
        setDateCalander={setDateCalander}
        dateCalender={dateCalender}
        handleSelectRange={handleSelectRange}
        model={model}
        handleReset={handleReset}
        handleDone={handleDone}
        filterModalRef={filterModalRef}
        wrapperRef={wrapperRef}
      />
      <div className="lg:mt-8">
        <div className="flex flex-row gap-3 sm:justify-end items-center">
          {/* <div className="flex justify-center items-center w-full sm:w-[170px] h-[40px] text-xs lg:text-[16px] border border-[#0B1D2E] rounded-[100px]">
            <div className="relative inline-block text-left">
              <button type="button" onClick={toggleDropdown} className="flex flex-row items-center">
                {selectedOption}
                <svg
                  className={`transform transition-transform ml-0 sm:ml-3 ${
                    isOpen ? 'rotate-180' : 'rotate-0'
                  }`}
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17.28 9.9668L12.9333 14.3135C12.42 14.8268 11.58 14.8268 11.0666 14.3135L6.71997 9.9668"
                    stroke="#0B1D2E"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
              {isOpen && (
                <div className="absolute left-[-12px] z-10 mt-1 w-[160px] bg-white divide-y divide-gray-100 rounded-md ring-1 ring-[#E7EAE8] ring-opacity-1">
                  <ul className="py-1 text-sm text-gray-700">
                    <li>
                      <button
                        onClick={() => handleOptionClick('Date Created')}
                        className="block px-4 py-2 w-full text-left hover:bg-gray-100"
                      >
                        Date Created
                      </button>
                    </li>
                    <li>
                      <button
                        onClick={() => handleOptionClick('Last Updated')}
                        className="block px-4 py-2 w-full text-left hover:bg-gray-100"
                      >
                        Last Updated
                      </button>
                    </li>
                    <li>
                      <button
                        onClick={() => handleOptionClick('Alphabetical')}
                        className="block px-4 py-2 w-full text-left hover:bg-gray-100"
                      >
                        Alphabetical
                      </button>
                    </li>
                  </ul>
                </div>
              )}
            </div>
          </div> */}
          <div
            onClick={togglePopUp}
            className=" cursor-pointer relative flex flex-row justify-center items-center w-full sm:w-[220px] h-[40px] bg-[#4A57DA] text-xs lg:text-[16px] rounded-[100px] text-[#FFFFFF]"
          >
            <button className="flex flex-row items-center" type="button">
              {SelfAssessmentPageData.newAssessmentBtnText}
            </button>
            <AddSurveyPopup
              open={isPopupOpen}
              setOpen={togglePopUp}
              popupOption={popupOption}
              path1={getPathForSurvey(
                "/self-assessment/create-self-assessment?type=1"
              )}
              path2={getPathForSurvey(
                "/self-assessment/create-self-assessment?type=0"
              )}
              handlePopuopOptionClick={(option) =>
                handlePopupOptionClick(option)
              }
              popupHeading={SelfAssessmentPageData.createAssessmentModal.title}
              firstTitle={SelfAssessmentPageData.createAssessmentModal.selectMenuOne.label}
              firstSubtitle={SelfAssessmentPageData.createAssessmentModal.selectMenuOne.subTitle}
              secondTitle={SelfAssessmentPageData.createAssessmentModal.selectMenuTwo.label}
              secondSubTitle={SelfAssessmentPageData.createAssessmentModal.selectMenuTwo.subTitle}
            />
          </div>
        </div>
        <div className="grid xl:grid-cols-4 lg:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-4 lg:mt-10 mt-5">

          <div className="dark:bg-shoorah-darkBgTabColor dark:border-none lg:w-full h-[96px] bg-[#FFFFFF] rounded-[8px] border-[1.5px] border-[#E7E8EA] flex items-center  pl-3  ">
            <div className="flex flex-row items-center w-full">
              <div className="flex justify-center w-1/4 items-center">
                <svg
                  width="56"
                  height="56"
                  viewBox="0 0 56 56"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect width="56" height="56" rx="28" fill="#C2EC97" />
                  <path
                    d="M28 38C33.5 38 38 33.5 38 28C38 22.5 33.5 18 28 18C22.5 18 18 22.5 18 28C18 33.5 22.5 38 28 38Z"
                    stroke="#0B1D2E"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M23.75 27.9999L26.58 30.8299L32.25 25.1699"
                    stroke="#0B1D2E"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
              <div className=" flex flex-col w-3/4 text-start ml-2">
                <p className="text-[14px] tracking-tight">
                  {SelfAssessmentPageData.cardSection.cardOneTitle}
                </p>
                <p className="text-[24px] font-medium">
                  {assessmentMatrics?.completedCount
                    ? assessmentMatrics?.completedCount
                    : 0}
                </p>
              </div>
            </div>
          </div>
          <div className="dark:bg-shoorah-darkBgTabColor dark:border-none lg:w-full h-[96px] bg-[#FFFFFF] rounded-[8px] border-[1.5px] flex items-center pl-3 border-[#E7E8EA]">
            <div className="flex flex-row items-center w-full">
              <div className="flex justify-center w-1/4 items-center">
                <svg
                  width="56"
                  height="56"
                  viewBox="0 0 56 56"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect width="56" height="56" rx="28" fill="#F05289" />
                  <path
                    d="M27.97 38C33.4928 38 37.97 33.5228 37.97 28C37.97 22.4772 33.4928 18 27.97 18C22.4471 18 17.97 22.4772 17.97 28C17.97 33.5228 22.4471 38 27.97 38Z"
                    stroke="white"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M23.21 32C24.26 33.51 26.02 34.5 28 34.5C29.98 34.5 31.73 33.51 32.79 32"
                    stroke="white"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
              <div className="flex flex-col w-3/4 text-start ml-2">
                <p className="text-[14px] tracking-tight">{SelfAssessmentPageData.cardSection.cardTwoTitle}</p>
                <p className="text-[24px] font-medium truncate">
                  {assessmentMatrics?.mostUsedAssessment || "-"}
                </p>
              </div>
            </div>
          </div>
          <div className="dark:bg-shoorah-darkBgTabColor dark:border-none lg:w-full h-[96px] bg-[#FFFFFF] rounded-[8px] border-[1.5px] flex items-center pl-3 border-[#E7E8EA]">
            <div className="flex flex-row items-center w-full">
              <div className="flex justify-center w-1/4 items-center">
                <svg
                  width="56"
                  height="56"
                  viewBox="0 0 56 56"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect width="56" height="56" rx="28" fill="#EDCC12" />
                  <path
                    d="M36.75 29.25C36.75 34.08 32.83 38 28 38C23.17 38 19.25 34.08 19.25 29.25C19.25 24.42 23.17 20.5 28 20.5C32.83 20.5 36.75 24.42 36.75 29.25Z"
                    stroke="#0B1D2E"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M28 24V29"
                    stroke="#0B1D2E"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M25 18H31"
                    stroke="#0B1D2E"
                    strokeWidth="1.5"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
              <div className="flex flex-col w-3/4 text-start ml-2">
                <p className="text-[14px] tracking-tight">{SelfAssessmentPageData.cardSection.cardThreeTitle}</p>
                <p className="text-[24px] font-medium">
                  {assessmentMatrics?.commanTime || "-"}
                </p>
              </div>
            </div>
          </div>

        </div>

        <HorizontalListCard
          title={SelfAssessmentPageData.horizontalCardSection.title}
          onViewAllTap={() => navigate("/self-assessment/view-all-assessment")}
          dataList={assessmentData}
          onDropDownSelect={(index, id) => {
            if (id === null) {
              errorToast("Assessment ID not found");
              return;
            }
            switch (index) {
              case 0:
                navigate(
                  `/self-assessment/create-self-assessment?view=4&id=${id}`
                );
                break;
              case 1:
                handleDeleteAssessment(id);
                break;
              case 2:
                navigate(
                  `/self-assessment/create-self-assessment?view=0&id=${id}`
                );
                break;
              default:
                errorToast("Invalid action");
            }
          }}
        />
      </div>
      <div className="lg:pb-5 w-full h-fit lg:mb-10">
        {assessmentMatrics && (
          <ValueCards
            isDashboard
            resultData={assessmentMatrics}
            time={isFilterOpen ? "Morning" : parameters?.common_time}
          />
        )}

        <div className="flex flex-col lg:flex-row md:flex-col gap-5 sm:w-full mt-[10px] lg:pb-4 overflow-x-auto horizontal-card-scrollbar overflow-y-hidden">

          <div className="flex flex-col min-w-[239px] justify-between w-full md:w-full lg:max-w-[239px] h-[200px] md:h-[200px] lg:h-[344px] bg-white rounded-xl border-[1.5px] border-[#E7E8EA] md:p-6 p-5 dark:bg-shoorah-darkBgTabColor dark:text-shoorah-darkBg dark:border-none">
            <p className="text-[20px] leading-tight font-medium text-shoorah-lightBlack dark:text-shoorah-darkBg">
              {SelfAssessmentPageData.bottomCardSection.cardOne.title}
            </p>
            <p className="lg:text-[64px] text-[48px] text-shoorah-lightBlack leading-tight font-medium dark:text-shoorah-darkBg">
              {IncompleteAssigment
                ? IncompleteAssigment === "100.00" ||
                  IncompleteAssigment === "100.0" ||
                  IncompleteAssigment === "100"
                  ? 100
                  : IncompleteAssigment?.toFixed(1)
                : 0}
              %
            </p>
          </div>

          <div className="flex flex-col min-w-[239px] justify-between w-full md:w-full lg:max-w-[239px] h-[344px] bg-white rounded-xl border-[1.5px] border-[#E7E8EA] md:p-6 p-5 dark:bg-shoorah-darkBgTabColor dark:text-shoorah-darkBg dark:border-none">
            <p className="text-shoorah-lightBlack text-[20px] dark:text-shoorah-darkBg font-medium">
              {SelfAssessmentPageData.bottomCardSection.cardTwo.title}
            </p>
            <div>
              <div className="max-w-full lg:max-w-full">
                <ProgressBar
                  label={SelfAssessmentPageData.bottomCardSection.cardTwo.optionLabelOne}
                  percentage={
                    assessmentMatrics?.dropOfCount?.introSectionPercentage
                      ? assessmentMatrics?.dropOfCount?.introSectionPercentage
                      : 0
                  }
                />
                <ProgressBar
                  label={SelfAssessmentPageData.bottomCardSection.cardTwo.optionLabelTwo}
                  percentage={
                    assessmentMatrics?.dropOfCount?.aboutSectionPercentage
                      ? assessmentMatrics?.dropOfCount?.aboutSectionPercentage
                      : 0
                  }
                />
                <ProgressBar
                  label={SelfAssessmentPageData.bottomCardSection.cardTwo.optionLabelThree}
                  percentage={
                    assessmentMatrics?.dropOfCount?.questionAttemptedPercentage
                      ? assessmentMatrics?.dropOfCount
                        ?.questionAttemptedPercentage
                      : 0
                  }
                />
              </div>
            </div>
          </div>

          <div className="h-[344px] max-w-[615px] w-full bg-white rounded-xl border-[1.5px] border-shoorah-borderGray px-5 py-6 dark:bg-shoorah-darkBgTabColor dark:text-shoorah-darkBg dark:border-none">
            <div className="flex justify-between w-full items-center mb-1">
              <p className="text-[20px] font-medium text-shoorah-lightBlack dark:text-shoorah-darkBg">
                {SelfAssessmentPageData.bottomCardSection.cardThree.title}
              </p>
              <p className="text-[20px] font-medium text-shoorah-lightBlack dark:text-shoorah-darkBg">
                {totalUsers} {SelfAssessmentPageData.bottomCardSection.cardThree.supportText}
              </p>
            </div>
            <div className="flex justify-between w-full items-center mb-[18px]">
              <p className="text-[14px] leading-5 text-shoorah-lightBlack dark:text-shoorah-darkBg flex gap-2 items-center">
                {moment(assessmentMatrics?.weeklyStats?.[0]?._id)?.format("Do")}{" "}
                -{" "}
                {moment(
                  assessmentMatrics?.weeklyStats?.[
                    assessmentMatrics?.weeklyStats?.length - 1
                  ]?._id
                )?.format("Do MMM, YYYY")}{" "}
                <ChevronDownIcon width={10} color="#2B2B33" />
              </p>
              <p className="text-[16px] font-medium leading-6 text-[#28D9A0] flex gap-1 items-center">
                {" "}
                <IoMdArrowDropup width={10} color="#28D9A0" />
                0%
              </p>
            </div>
            <Bar
              data={dataD || data}
              options={{
                ...options,
                responsive: true,
                maintainAspectRatio: false,
              }}
              className="!dark:text-shoorah-darkBg !h-[222px]"
            />
          </div>
          <div className="2xl:block hidden flex-col justify-between w-full h-[344px] rounded-xl border-[1.5px] border-shoorah-borderGray bg-shoorah-normanGray dark:bg-shoorah-darkBgColor border-none dark:text-shoorah-darkBg dark:border-none"></div>
        </div>
      </div>
    </div>
  );
};
export default SelfAssessmentDashboard;
